const copy = {
  ariaLabel: {
    feedbackAction: "Feedback action",
    positiveFeedback: "This is a helpful response",
    negativeFeedback: "This is not a helpful response",
  },
  fields: {
    details: "Please include any relevant details",
    ariaLabel: "details",
    ariaDescribedBy: "details",
  },
  ctas: {
    feedback: "Is this helpful?",
    cancel: "Cancel",
    submit: "Submit feedback",
  },
  errors: {
    feedbackMinLength:
      "Message is too short. Your message must be at least 10 characters.",
    feedbackSubmissionHeader: "Server connection failed",
    feedbackSubmissionText: "Try again later.",
  },
  form: {
    thumbsUpSuccess: "Feedback submitted",
  },
  contactSupport: {
    label: "Need additional support?",
    ctas: {
      login: "Login to contact support",
      liveChat: "Chat with a live agent",
      ungatedSubmitTicket: "Can't login? Submit a ticket",
      gatedSubmitTicket: "Submit a ticket",
      redirectToHelpCenter: "Go to Twilio Help Center",
    },
  },
};

export default copy;
